module.exports = __webpack_public_path__ + "static/img/YMTlogo.182b605.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/YMTlogo.png
// module id = V2Hr
// module chunks = 1